import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WordCloudComponent } from './wordCloud.component';
import { TranslateModule } from '@ngx-translate/core';
import { AngularD3CloudModule } from 'angular-d3-cloud';
import { PlSlicePipe } from '@shared/pipes/plSlice/plSlice.pipe';

@NgModule({
  imports: [CommonModule, TranslateModule, AngularD3CloudModule],
  providers: [PlSlicePipe],
  declarations: [WordCloudComponent],
  exports: [WordCloudComponent],
})
export class WordCloudModule {}
